import { TConditionalHelperDependencies } from '@kurtosys/types/helpers/TConditionalHelperDependencies.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { helpers } from '../../common/index.js';

import { BaseTransform } from './BaseTransform.js';

export class VisibleTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		const { visibleOptions } = this.options;
		let response = queryResponse;
		if (visibleOptions) {
			const { mode, conditional, hideValue } = visibleOptions;
			const conditionalHelperDependencies: TConditionalHelperDependencies = {
				queryClass: this.dependencies.queryClass,
			};

			const conditionalHelper = new helpers.ConditionalHelper(
				conditionalHelperDependencies,
				conditional,
				this.translationHelper,
			);
			const conditionMatches = conditionalHelper.matchesWithOptions({
				executionOptions,
				instance: queryResponse,
			});

			const hide = mode === 'hide';
			const show = mode === 'show';

			if ((hide && conditionMatches) || (show && !conditionMatches)) {
				response = hideValue;
			}
		}

		return response;
	}
}
